<template>
    <app-modal-view @close="$emit('close')">
        <template #body>
            <div
                v-for="(section, title) in preferencesModel"
                :key="title"
                class="py-2"
                @click="activeDropdown = undefined"
            >
                <p
                    v-t="`Community.preferences_${title}_title`"
                    class="title is-3"
                ></p>
                <div
                    v-for="(value, option) in section"
                    :key="option"
                    class="box"
                >
                    <div class="level">
                        <div class="level-left">
                            <div class="level-item">
                                <p
                                    v-t="`Community.preferences_${option}`"
                                    class="title is-6"
                                ></p>
                            </div>
                        </div>
                        <div class="level-right">
                            <div class="level-item">
                                <label
                                    v-if="typeof section[option] == 'boolean'"
                                    class="switch"
                                >
                                    <input
                                        v-model="activeConfiguration[option]"
                                        type="checkbox"
                                    />
                                    <span class="slider round"></span>
                                </label>
                                <div
                                    v-else
                                    :class="{
                                        'is-active': option == activeDropdown,
                                    }"
                                    class="dropdown"
                                >
                                    <div
                                        class="dropdown-trigger"
                                        @click.stop="activeDropdown = option"
                                    >
                                        <button
                                            class="button"
                                            aria-haspopup="true"
                                            aria-controls="dropdown-menu"
                                        >
                                            <span>{{
                                                $t(
                                                    `Constants.${activeConfiguration[option]}`
                                                ) || $t('Buttons.select')
                                            }}</span>
                                            <span class="icon is-small">
                                                <i
                                                    class="fas fa-angle-down"
                                                    aria-hidden="true"
                                                ></i>
                                            </span>
                                        </button>
                                    </div>
                                    <div
                                        id="dropdown-menu"
                                        class="dropdown-menu"
                                        role="menu"
                                    >
                                        <div class="dropdown-content">
                                            <a
                                                v-for="constant in value"
                                                :key="constant"
                                                v-t="`Constants.${constant}`"
                                                class="dropdown-item"
                                                @click="
                                                    activeConfiguration[
                                                        option
                                                    ] = constant
                                                "
                                            >
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </app-modal-view>
</template>

<script>
import AppModalView from '@/components/AppModalView';
import _ from 'underscore';
import { updateCommunityPreferences } from '@/services/API';
export default {
    components: {
        AppModalView,
    },
    props: {
        preferences: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            activeDropdown: undefined,
            activeConfiguration: JSON.parse(
                JSON.stringify(this.$store.getters.community.preferences)
            ),
            preferencesModel: {
                new_content: {
                    new_activity: false,
                    new_post: false,
                    mentions: false,
                },
                reports: {
                    report_frequency: ['NONE', '1D', '3D', '1W', '1M'],
                },
            },
        };
    },
    watch: {
        activeConfiguration: {
            deep: true,
            handler() {
                updateCommunityPreferences(
                    this.$store.getters.community._id,
                    this.activeConfiguration
                ).then((result) => {
                    this.$store.dispatch(
                        'updateCommunityConfiguration',
                        result.data
                    );
                });
            },
        },
    },
};
</script>

<style></style>
